<template>
  <div class="page-view bracket-custom-style">
    <Spin v-if="showSpinner" fix style="z-index: 999;">
      <Icon class="demo-spin-icon-load" size="40" type="ios-loading"></Icon>
      <div>{{ $t("global.loading") }}</div>
    </Spin>
    <div>
      <Affix :offset-top="0" class="affix-header-style">
        <div class="affix-header-row-style">
          <div
            class="mb-2 mb-md-0 d-flex align-items-center"
            style="min-width: 300px; height: 31px;"
          >
            <span class="page-title" v-if="competition">
              {{ competition.name }} | <br />
              {{ getCategory().name }} |
              <span
                v-if="
                  competition &&
                    competition.stages.find(
                      stage =>
                        (stage.isChosen ? stage.isChosen : stage.isCurrent) &&
                        stage.category === category
                    )
                "
                class="mt-3 mb-4"
              >
                {{ $t("competition.current") }} - {{ $t("competition.stage") }}
                {{
                  competition.stages
                    .filter(stage => stage.category === category)
                    .findIndex(stage =>
                      stage.isChosen ? stage.isChosen : stage.isCurrent
                    ) + 1
                }}
              </span>
            </span>
          </div>
          <div
            v-if="renderComponent"
            :class="
              enableFor(['admin', 'super']) ? 'affix-header-fill-available' : ''
            "
          >
            <div v-if="isVisible" class="text-right">
              <Button
                @click="() => save()"
                :disabled="!canSave"
                size="large"
                type="success"
                class="save-button-style"
              >
                {{ $t("global.save") }}
              </Button>
            </div>
            <div
              v-else
              class="d-flex justify-content-end text-right affix-button-block-style"
              :gap="10"
            >
              <Button
                v-if="
                  enableFor(['super']) &&
                    this.competition.stages.find(
                      stage => stage.isChosen && stage.isCurrent
                    )
                "
                :disabled="matches.filter(match => !match._id).length > 0"
                @click="restartStage"
                type="error"
              >
                {{ $t("competition.restart_stage") }}
              </Button>
              <Button
                v-if="visibilityBetweenStages"
                @click="() => updateFormat()"
                type="success"
              >
                {{ $t("competition.save_format") }}
              </Button>
              <Button
                v-if="
                  matches.length > 0 &&
                    matches.every(match => !match._id) &&
                    (type === 'group' ? !isDraggable : true)
                "
                @click="() => saveOrder()"
                :disabled="disabledCondition()"
                type="primary"
              >
                {{ $t("competition.save_order") }}
              </Button>
              <Button
                v-else-if="
                  enableFor(['super']) &&
                    matches.length > 0 &&
                    !matches
                      .filter(match => match._id)
                      .some(match => match.isFinished) &&
                    (type === 'group' ? !isDraggable : true)
                "
                @click="() => deleteOrder()"
                type="primary"
              >
                {{ $t("competition.delete_order") }}
              </Button>
              <Button @click="() => generateMatchesPDF()" type="success">
                Procese Verbale
              </Button>
              <ButtonGroup class="d-flex">
                <Button
                  v-for="(comp, i) in competition.stages.filter(
                    stage =>
                      (stage.rounds.length || stage.isCurrent) &&
                      stage.category === $route.params.cat
                  )"
                  :key="comp._id"
                  :disabled="
                    comp._id ===
                      competition.stages.find(
                        stage =>
                          (stage.isChosen ? stage.isChosen : stage.isCurrent) &&
                          stage.category === $route.params.cat
                      )._id
                  "
                  class="stage-list-button"
                  @click="() => setStage(comp._id)"
                >
                  {{ $t("competition.stage") }} {{ i + 1 }}
                </Button>
              </ButtonGroup>
              <Button
                v-if="
                  competition.stages.find(
                    stage =>
                      stage.isChosen &&
                      stage.isCurrent &&
                      stage.category === $route.params.cat
                  ) &&
                    competition.stages
                      .filter(stage => stage.category === $route.params.cat)
                      .findIndex(stage => stage.isCurrent) !==
                      competition.stages.filter(
                        stage => stage.category === $route.params.cat
                      ).length -
                        1 &&
                    nextStageIsAvailable &&
                    (type === 'group'
                      ? matches.every(match => match.isFinished) &&
                        playoffs.length &&
                        playoffs.every(match => match.isFinished)
                      : matches.every(match => match.isFinished)) &&
                    !partAccess &&
                    enableFor(['admin', 'super'])
                "
                type="warning"
                @click="() => detectCurrentStage()"
              >
                <b>{{ $t("competition.next") }}</b>
              </Button>
              <Button
                v-if="enableFor(['admin', 'super'])"
                :disabled="!canFinishCompetition"
                @click="() => finishCompetition()"
                type="success"
              >
                {{ $t("competition.finish") }}
              </Button>
            </div>
          </div>
        </div>
      </Affix>
      <div class="d-flex w-100 h-100 editor">
        <BracketsSidebar />
        <BracketsView />
        <div class="emn">
          <div class="emn-buttons">
            <div class="emn-button emn-button-settings  emn-button-active">
              <div class="icon icon-slider"></div>
              <span>Settings</span>
            </div>
            <div class="emn-button emn-button-preview">
              <div class="icon icon-eye"></div>
              <span>Preview</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import bracketsMixin from "./bracketsMixin";
import BracketsSidebar from "./BracketsSidebar.vue";
import BracketsView from "./BracketsView.vue";
export default {
  name: "Brackets",
  components: { BracketsSidebar, BracketsView },
  data() {
    return bracketsMixin;
  },
  watch: {
    loading(n, o) {
      if (n === true) {
        if (this.showSpinner === false) {
          this.showSpinner = true;
        }
      } else {
        if (this.showSpinner === true) {
          setTimeout(() => {
            this.showSpinner = false;
          }, 1000);
        }
      }
    },
    visibilityBetweenStages(n, o) {
      console.log({ n, o });
    }
  },
  methods: {
    async restartStage() {
      this.$dialog
        .confirm(this.$t("competition.restart_stage"), {
          okText: this.$t("global.yes"),
          cancelText: this.$t("global.no"),
          html: true,
          customClass: "mahnung-confirm"
        })
        .then(async _dialog => {
          await this.deleteMatches();
          window.location.reload();
        })
        .catch(error => {
          console.log(error);
        });
    },
    async saveOrder() {
      await this.addMoreMatches();
      this.forceRerender();
    },
    async deleteOrder() {
      await this.deleteMatches();
      this.forceRerender();
    },
    disabledCondition() {
      let typeEq =
        this.type ===
        this.competition.formats.find(
          format =>
            format.category._id === this.$route.params.cat &&
            format.stage === localStorage.getItem("chosenStage")
        ).format_type;
      let specEq =
        this.spec ===
        this.competition.formats.find(
          format =>
            format.category._id === this.$route.params.cat &&
            format.stage === localStorage.getItem("chosenStage")
        ).spec;
      let sizeEq =
        this.sizeOfBrackets ===
        this.competition.formats.find(
          format =>
            format.category._id === this.$route.params.cat &&
            format.stage === localStorage.getItem("chosenStage")
        ).sizeOfBrackets;
      let qtyEq =
        this.qty ===
        this.competition.formats.find(
          format =>
            format.category._id === this.$route.params.cat &&
            format.stage === localStorage.getItem("chosenStage")
        ).group_qty;
      if (this.type === "group" && typeEq && sizeEq && qtyEq) {
        return false;
      } else if (this.type === "circuit" && typeEq && specEq) {
        return false;
      }
      return true;
    }
  },
  created() {
    this.category === this.$route.params.cat;
    var $ = window.$;
    $(window).ready(function() {
      $(".emn-button").click(function() {
        $(this).hasClass("emn-button-active") ||
          ($(".emn-button-active").removeClass("emn-button-active"),
          $(this).addClass("emn-button-active"),
          $(this).hasClass("emn-button-preview")
            ? $(".editor").addClass("editor-preview")
            : $(".editor").removeClass("editor-preview"));
      });

      $(".button-view-bracket-mobile").click(function() {
        $(".emn-button-preview").click();
      });
    });
  }
};
</script>
<style scoped>
@import "./brackets.css";
@media only screen and (min-width: 0px) and (max-width: 568px) {
  .editor .panel .panel-content {
    padding-left: 0px !important;
  }
  .bracket-custom-style .viewport {
    padding-left: 0px !important;
  }
}

.page-view {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
}

.affix-header-style {
  z-index: 99 !important;
  position: relative;
  top: 0;
  left: 0;
  /* height: 100%; */
  min-height: 55px;
  width: 100%;
  background: #373a42;
  color: #e8e8e8;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.8);
  padding: 10px;
}

.save-button-style {
  box-shadow: 0 1px 6px rgba(90, 187, 115, 0.3);
}

:global(ul.custom-stage-count.ivu-page .ivu-page-item:last-child) {
  display: none !important;
}

.bracket-custom-style :global(.ivu-spin) {
  background: #454751 !important;
  color: #ffffff;
}

.bracket-custom-style .viewport {
  padding-left: 350px;
}

.custom-spin {
  position: fixed;
  display: inline-block;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 999;
}

.affix-header-row-style {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.affix-button-block-style {
  display: flex;
  justify-content: end;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.stage-list-button:disabled,
.stage-list-button[disabled] {
  background-color: rgb(45, 183, 245);
  border-color: rgb(45, 183, 245);
  color: white;
}

.affix-header-fill-available {
  width: -webkit-fill-available;
}

@media only screen and (max-width: 767.98px) {
  .affix-header-row-style,
  .affix-button-block-style {
    flex-wrap: wrap;
  }
}

@media only screen and (max-width: 959px) {
  .bracket-custom-style .viewport {
    padding-left: 0;
    padding-top: 0;
  }

  .bracket-custom-style .viewport .viewport-scroll {
    padding: 50px 0;
  }

  .bracket-custom-style .editor {
    position: relative !important;
    /* padding-bottom: 55px; */
    height: calc(100% - 55px) !important;
  }

  .page-view.bracket-custom-style {
    display: inline-block !important;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/competitions/brackets/Brackets.vue